// Suppress an identical toast (same colour + title + text) fired again within
// this window. Several save flows validate through the shared form mixin (which
// already notifies on missing fields) and then notify again themselves, which
// would otherwise stack two identical toasts for a single action.
const DEDUPE_WINDOW_MS = 800;
let lastNotification = { key: null, at: 0 };

export default {
  methods: {
    dispatchNotification(options) {
      const key = [options.color, options.title, options.text].join('|');
      const now = Date.now();

      if (lastNotification.key === key && now - lastNotification.at < DEDUPE_WINDOW_MS) {
        return;
      }

      lastNotification = { key, at: now };
      this.$vs.notify(options);
    },
    notifyError(message, title = 'An error has occurred') {
      this.dispatchNotification({
        color: 'danger',
        title: title,
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        position: 'top-right'
      });
    },
    notifyWarning(message, title = 'Warning') {
      this.dispatchNotification({
        color: 'warning',
        title: title,
        text: message,
        iconPack: 'feather',
        position: 'top-right'
      });
    },
    notifySuccess(message, title = 'Success') {
      this.dispatchNotification({
        color: 'success',
        title: title,
        text: message,
        iconPack: 'feather',
        position: 'top-right'
      });
    },
    notifyMissingFields(title = 'An error has occurred') {
      this.dispatchNotification({
        color: 'danger',
        title: title,
        text: 'Not all required fields have been provided',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        position: 'top-right'
      });
    }
  },
};
